module.exports = __webpack_public_path__ + "static/media/diners.c2bbc1d7.webp";